import { useEffect } from 'react';

import Switch from '../../../../lib/switch';
import { useBoard } from '../../../../pages/CaseBoard/useBoard';
import usePostCallAvailability from '../../../../services/Twilio/usePostCallAvailability';
import { AnsweringCallsSwitchProps } from './types';
import { Skeleton } from '../../../../lib/skeleton';

const AnsweringCallsSwitch: React.FC<AnsweringCallsSwitchProps> = ({ isUserAnswering }) => {
    const { isAnsweringCalls, setIsAnsweringCalls } = useBoard();
    const { mutate: postCallAvailability, isLoading } = usePostCallAvailability();

    useEffect(() => {
        if (isAnsweringCalls !== isUserAnswering) setIsAnsweringCalls(isUserAnswering);
    }, [isUserAnswering, isAnsweringCalls, setIsAnsweringCalls]);

    const handleSwitch = () => postCallAvailability({ is_available: !isAnsweringCalls });

    return (
        <div className="flex w-full justify-between items-center border-t border-gray-200 p-4 hover:cursor-pointer">
            {!isLoading ? (
                <>
                    <label className="text-xs" htmlFor="answering-calls">
                        Answering calls
                    </label>
                    <Switch
                        checked={isAnsweringCalls}
                        onCheckedChange={handleSwitch}
                        id="answering-calls"
                        disabled={isLoading}
                    />
                </>
            ) : (
                <>
                    <Skeleton className="w-28 h-4 mr-2" />
                    <Skeleton className="w-10 h-4" />
                </>
            )}
        </div>
    );
};
export default AnsweringCallsSwitch;
